export enum LeadModeType {
  NEW = 'new',
  CHECKIN = 'checkin',
  CHECKOUT = 'checkout',
}
